import type { IScreensLogging } from '../../../../../api/types';
import { bridge } from '../../../../../utils';

type LogOnPressLikeProps = {
  logging: IScreensLogging;
  currentLike: boolean;
};

export const logOnPressLike = ({
  logging,
  currentLike,
}: LogOnPressLikeProps) => {
  const name = currentLike ? 'CLICK_UNLIKE_GOODS' : 'CLICK_LIKE_GOODS';

  bridge.logAnalyticsEvent({
    channel: ['firebase', 'amplitude', 'ablylog', 'facebook'],
    name,
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
